/**
 * Article module.
 *
 * This module will take care of infinite scroll paging
 * for articles.
 *
 *
 */

/**
 * Include the dependencies.
 */
var $ = require('jquery');
var rest = require('./rest');
var toc = require('./table_of_contents');
var feature = require('./feature');
var ads = require('./ads');
var did_scroll;
var irAttributes = window.irAttributes || {};

/**
 * The loader element.
 * @type {*|jQuery|HTMLElement}
 */
var $loader_elem = $('.article-single #loader');

/**
 * The inital parent article element.
 *
 * This is the first rendered article
 * parent element. We'll get the others
 * based on the post id in the
 * rest callback.
 *
 * @type {*|jQuery|HTMLElement}
 */
var $initial_article_elem = $('div[id^=article-post-id-]');

/**
 *
 * Scroll related fields
 */
var prevTop        = $(window).scrollTop(),
    windowHeight   = $(window).height(),
    documentHeight = $(document).height();

/**
 * Counter to track how many articles are lazy loaded.
 * @type {number}
 */
var lazyLoadCount = 0;

/**
 * The infinite scroll next page callback.
 *
 * 1. Append the markup to the parent element.
 *
 * 2. Add the table of contents.
 *
 * 3. Hide the loader.
 *
 * 4. If there is another article to fetch,
 * toggle the has-next-article class back.
 * Update the ad counter.
 * Just wait a little bit to let the dom render.
 *
 * @param data
 */
var nextArticleCallback = function (data) {
    var parent_elem = data.query.domID;

    $loader_elem.hide();

    $(parent_elem).append(data.markup).fadeIn(999);

    var $article_elem = $('div[id^=article-post-id-' + data.post_id + ']');

    if (true === data.next_page) {
        $(parent_elem).toggleClass('has-next-article');
        $(parent_elem).data('query', data.query);
        articleScroll();
    }

    addToc($article_elem);
    social($article_elem);
    feature.updateFeature($article_elem);
    updateDataLayer();
    ads.updateAds();

    /*
     * Sticky for social and left rail
     */
    if( $('.left-rail.desktop-only', $article_elem).length > 0 && $('#bottom-links', $article_elem).length > 0 ) {
        $('.left-rail.desktop-only', $article_elem).affix({
            offset: {
                top: $('.left-rail.desktop-only', $article_elem).offset().top - 20,
                bottom: function(){ return( $('body').innerHeight() - $('#bottom-links', $article_elem).offset().top + $('#bottom-links', $article_elem).outerHeight()); }
            }
        });
    }
    if( $('.right-rail.desktop-only', $article_elem).length > 0 && $('#bottom-links', $article_elem).length > 0 ) {
        $('.right-rail.desktop-only', $article_elem).affix({
            offset: {
                top: $('.left-rail.desktop-only', $article_elem).offset().top - 20,
                right: 0,
                bottom: function(){ return( $('body').innerHeight() - $('#bottom-links', $article_elem).offset().top + $('#bottom-links', $article_elem).outerHeight()); }
            }
        });
    }

    if( $('.social.mobile-only', $article_elem).length > 0 && $('#bottom-links', $article_elem).length > 0 ) {
        $('.social.mobile-only', $article_elem).affix({
            offset: {
                top: $('.social.mobile-only', $article_elem).offset().top,
                bottom: function(){ return( $('body').innerHeight() - $('#bottom-links', $article_elem).offset().top + $('#bottom-links', $article_elem).outerHeight()); }
            }
        });
    }
};

/**
 * Get the next article.
 *
 * 1. Unbind the scroll event to prevent
 * repeated loading.
 *
 * 2. Check if the has-next-article class is
 * on the parent, if not don't do anything.
 *
 * 3. if it has the class:
 *  a. Toggle the has-next-article class
 *  b. Update the pager
 *  c. get the data-query and set the page and domID
 *  to be used int eh rest call
 *  d. show the loader
 *  c. make the rest call
 *
 *  Limit the articles to 5.
 *
 * @param $parent
 */
var getNextArticle = function ($parent) {

    // $(window).unbind('scroll', scrollHandler);

    if ($parent.hasClass('has-next-article')) {

        $parent.toggleClass('has-next-article');

        var next_page = $parent.data('page') + 1;

        if (next_page < 6) {

            $parent.data('page', next_page);

            var query = $parent.data('query');

            query.page = next_page;
            query.domID = '#article-container';

            rest.postJson('/wp-json/ir/v1/post/next-article', query, nextArticleCallback);
            $loader_elem.show();

        }
    }
};

/**
 * Trigger the next article load when reaching
 * the "bottom" of the page.
 *
 * We want to trigger the next article load before
 * the user gets to the bottom of the article they
 * are reading. We just need to ake a estimated guess
 * of that offset from the bottom of the page.
 *
 * @param $parent
 */
var scrollHandler = function () {
    did_scroll = true;

    /**
     * Global scroll event
     */
    var scrollTop = $(window).scrollTop();
    $(document).trigger('ir.window.scroll', {
        scrollTop: scrollTop,
        prevTop: prevTop,
        windowHeight: windowHeight,
        documentHeight: documentHeight
    });
    prevTop = scrollTop;

    if ($(window).scrollTop() + $(window).height() >= $(document).height() - 2000) {
        var $parent = $('#article-container');
        getNextArticle($parent);
    }
};

// // Every 250ms, check if the page scrolled for URL change
// setInterval(function(){
//     if (did_scroll) {
//         updateURL();
//         did_scroll = false;
//     }
// }, 250);
//
// Update the URL
function updateURL() {
    var new_url;
    var $in_viewport = $('div[id^="article-post-id-"]:in-viewport').first();
    var old_url = window.location.href;
    addshopNewArticleReload($in_viewport);
    if (history.replaceState) {
        //Get data-url
        new_url = $in_viewport.data('url');
        if (old_url !== new_url) {
            history.replaceState('', '', new_url);

            //send analytics
            sendGApageview(new_url);
        }
    }
}

//Sending GA page view trigger
function sendGApageview(new_url) {
    if ('undefined' !== typeof ga) {
        ga('set', 'page', new_url);
        ga('send', 'pageview');
    }
}

/**
 * Update the dataLayer object.
 *
 * This is used for google analytics.
 */
function updateDataLayer() {
    lazyLoadCount++;
    dataLayer.push({'article_count': lazyLoadCount });
}

/**
 * Set the scroll handler function.
 *
 * We need to be able to remove this and readd it
 * after the article is fetched so the scroll event
 * doesn't keep happening.
 */
var articleScroll = function () {
    if ($('#article-container').length > 0) {
        $(window).scroll(scrollHandler).resize(function () {
            windowHeight = $(window).height();
            documentHeight = $(document).height();
        }).scroll();
    }
};

var addToc = function ($article_elem) {
    if ($article_elem.length > 0) {
        toc.setToc($article_elem);
        // social($article_elem[0]);
    }
};



var shareEvent = function() {

    $('.share .social a.icon, .social a.icon').each(function (event) {

        $(this).on('click', function (e) {
            e = (e ? e : window.event);
            e.preventDefault();

            var t = (e.target ? e.target : e.srcElement);
            if( typeof(AddShoppersWidget) !== "undefined" ){
                //AddShoppers widget exists on page!
                var service = $(t).data('service');
                if(service)  {
                    AddShoppersWidget.app(service, true);

                }

            }else {
                var url = $(this).attr('href'),
                    width = 500,
                    height = 500;

                // popup position
                var px = Math.floor(((screen.availWidth || 1024) - width) / 2),
                    py = Math.floor(((screen.availHeight || 700) - height) / 2);

                // open popup
                var popup = window.open(url, "social",
                    "width=" + width + ",height=" + height +
                    ",left=" + px + ",top=" + py +
                    ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
                if (popup) {
                    popup.focus();
                    e.preventDefault();
                    e.returnValue = false;
                }

                return !!popup;
            }


        });

    });

};

/**
 * Add a tweet this link to blockquotes.
 *
 */
var addTweetThis = function () {

    $('.article-single blockquote, .shortcode-ui-blockquote').each(function (event) {
        var page_title = $('meta[property="og:title"]').attr('content');
        var url = window.location.href;
        $(this).after('<span class="social twitter shortcode-quote"><a class="icon fa fa-twitter" href="https://twitter.com/intent/tweet?url=' + window.location.href + '&amp;text=' + page_title + '" target="_blank" rel="nofollow"> </a><a class="twitter-text" href="https://twitter.com/intent/tweet?url=' + window.location.href + '&amp;text=' + page_title + '" target="_blank" rel="nofollow">Tweet This</a></span>');
    });

    shareEvent();

};

var social = function ($ele) {

    var $article_ele = $($ele),
        $outer = $('#post-social-links-desktop', $article_ele),
        $social = $('.social-links.share > .social', $outer),
        $bottom_links = $('#bottom-links', $article_ele);

        if( $social.length > 0 ) {
            var heights = {
                    social: $social.outerHeight(true),
                    bottom: $bottom_links.outerHeight(true)
                },
                tops = {
                    social: $social.offset().top,
                    content: $social.offset().top + heights.social
                };
            shareEvent();
        }
};

/**
 * Reload the data for the Add Shopper Socual widget.
 * @param $article_elem
 */
var addshopNewArticleReload = function ($article_elem) {
    if ( "undefined" !== typeof(AddShoppersWidget) ) {
        AddShoppersTracking = {
            image: $article_elem.data("image"),
            url: $article_elem.data("url"),
            name: $article_elem.data("name"),
            description: $article_elem.data("description")
        };
        AddShoppersWidget.API.reload();
    }
};

/**
 * Sticky From Function
 *
 */
var stickyForm = function () {
    if ( $(window).innerWidth() < 992 ) {
        return false;
    }

    var $stickyForm = $('.stickyForm');

    if ( $stickyForm.length > 0 ) {
        var $primaryWrap = $('#primary');

        $(window).scroll(function () {
            var scrollTop = $(window).scrollTop();
            var wrapHeight = $primaryWrap.height();
            var wrapOffsetTop = $primaryWrap.offset().top;
            var stickyFormHeight = $stickyForm.height();

            if ( scrollTop > wrapOffsetTop ) {
                $stickyForm.addClass('position-absolute');
                $stickyForm.css('top', scrollTop - wrapOffsetTop + 30);
            } else {
                $stickyForm.removeClass('position-absolute');
            }

            if ( scrollTop > (wrapOffsetTop + wrapHeight - stickyFormHeight) ) {
                // $stickyForm.removeClass('position-absolute');
                $stickyForm.parent().height(wrapHeight);
                $stickyForm.css({'top': 'unset', 'bottom': 0});
            }
        })
    }
}

/**
 * Methods to execute immediately.
 */
var init = function () {
    // articleScroll();
    addToc($initial_article_elem);
    addTweetThis();
    // stickyForm();
};

/**
 * Export all of the methods.
 */
module.exports = {
    init: init
};

